import { render, staticRenderFns } from "./parameterList.vue?vue&type=template&id=b8ce0016&scoped=true&"
import script from "./parameterList.vue?vue&type=script&lang=js&"
export * from "./parameterList.vue?vue&type=script&lang=js&"
import style0 from "./parameterList.vue?vue&type=style&index=0&id=b8ce0016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ce0016",
  null
  
)

export default component.exports